import { Routes } from '@angular/router';
import { ProductsOverviewComponent } from './pages/product-overview/products-overview.component';
import { HomeComponent } from './pages/home/home.component';
import { PageComponent } from './pages/page/page.component';
import { ProductComponent } from './pages/product/product.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'producten',
    component: ProductsOverviewComponent
  },
  {
    path: 'producten/:slug',
    component: ProductsOverviewComponent
  },
  {
    path: 'producten/:parentSlug/:slug',
    component: ProductsOverviewComponent
  },
  {
    path: 'producten/:categorySlug/:id',
    component: ProductComponent
  },
  {
    path: 'producten/:parentCategorySlug/:categorySlug/:id',
    component: ProductComponent
  },
  {
    path: ':slug',
    component: PageComponent
  }
];
